module.exports = __webpack_public_path__ + "img/diamond.394216e1.webp";